export default function Tabs(theme) {
  return {
    MuiTabs: {
      styleOverrides: {
        root: {
          padding: 0,

          // "& .MuiTabs-flexContainer": {
          //   flexWrap: "wrap",
          // },
        },
        indicator: {
          bottom: 10,
        },
      },
    },
  };
}
